var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 14306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5659 12.3828C16.8357 12.0715 17 11.6605 17 11.2109C17 10.2418 16.2373 9.45312 15.3 9.45312H12.0005C12.3273 8.42773 12.4667 7.06719 12.4667 6.48398V5.89844C12.4667 4.60625 11.4497 3.55469 10.2 3.55469H9.63333C9.37342 3.55469 9.14676 3.7375 9.08367 3.99844L8.77502 5.27539C8.34247 7.06367 6.96924 9.03672 5.54804 9.39531C5.29909 8.74375 4.68444 8.28125 3.96667 8.28125H0.566667C0.253867 8.28125 0 8.54375 0 8.86719V19.4141C0 19.7375 0.253867 20 0.566667 20H3.96667C4.64251 20 5.22731 19.5902 5.5012 18.998L7.44827 19.6691C8.08482 19.8887 8.7482 20 9.41951 20H14.1667C15.1039 20 15.8667 19.2113 15.8667 18.2422C15.8667 18.0137 15.8244 17.7949 15.7473 17.5945C16.4681 17.391 17 16.7078 17 15.8984C17 15.4488 16.8357 15.0379 16.5659 14.7266C16.8357 14.4152 17 14.0043 17 13.5547C17 13.1051 16.8357 12.6941 16.5659 12.3828ZM4.53333 18.2422C4.53333 18.5652 4.27909 18.8281 3.96667 18.8281H1.13333V9.45312H3.96667C4.27909 9.45312 4.53333 9.71602 4.53333 10.0391V18.2422ZM14.1667 12.9688H15.3C15.6124 12.9688 15.8667 13.2316 15.8667 13.5547C15.8667 13.8777 15.6124 14.1406 15.3 14.1406H14.1667C13.8539 14.1406 13.6 14.4031 13.6 14.7266C13.6 15.05 13.8539 15.3125 14.1667 15.3125H15.3C15.6124 15.3125 15.8667 15.5754 15.8667 15.8984C15.8667 16.2215 15.6124 16.4844 15.3 16.4844H14.1667C13.8539 16.4844 13.6 16.7469 13.6 17.0703C13.6 17.3938 13.8539 17.6562 14.1667 17.6562C14.4791 17.6562 14.7333 17.9191 14.7333 18.2422C14.7333 18.5652 14.4791 18.8281 14.1667 18.8281H9.41951C8.87022 18.8281 8.32736 18.7371 7.8064 18.5574L5.66667 17.8199V10.5695C6.55558 10.3949 7.4256 9.81289 8.211 8.86016C8.97789 7.92969 9.59971 6.69609 9.87436 5.55977L10.0757 4.72656H10.2C10.8248 4.72656 11.3333 5.25234 11.3333 5.89844V6.48398C11.3333 7.2707 11.0953 8.77969 10.7908 9.45312H9.63333C9.32053 9.45312 9.06667 9.71562 9.06667 10.0391C9.06667 10.3625 9.32053 10.625 9.63333 10.625H15.3C15.6124 10.625 15.8667 10.8879 15.8667 11.2109C15.8667 11.534 15.6124 11.7969 15.3 11.7969H14.1667C13.8539 11.7969 13.6 12.0594 13.6 12.3828C13.6 12.7063 13.8539 12.9688 14.1667 12.9688Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7669 0C10.4539 0 10.2002 0.262344 10.2002 0.585938V1.79688C10.2002 2.12047 10.4539 2.38281 10.7669 2.38281C11.0798 2.38281 11.3335 2.12047 11.3335 1.79688V0.585938C11.3335 0.262344 11.0798 0 10.7669 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.362 2.58387L7.56062 1.75524C7.33935 1.52641 6.98054 1.52641 6.75924 1.75524C6.53794 1.98407 6.53794 2.35504 6.75924 2.58387L7.56062 3.41251C7.78188 3.64129 8.14073 3.64133 8.362 3.41251C8.5833 3.18368 8.5833 2.8127 8.362 2.58387Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.7736 1.75524C14.5524 1.52641 14.1935 1.52641 13.9722 1.75524L13.1709 2.58383C12.9496 2.81266 12.9496 3.18364 13.1709 3.41247C13.3921 3.64129 13.7509 3.64133 13.9722 3.4125L14.7736 2.58387C14.9949 2.35504 14.9949 1.98407 14.7736 1.75524Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeBorder);
export default __webpack_public_path__ + "static/media/like-border.48dbbf224b9347a3be46da84b3ce438e.svg";
export { ForwardRef as ReactComponent };